export default {
  title: 'Add-ons for greater success',
  description: 'Upgrade your plan with additional features',
  buttons: {
    continue: 'Continue',
    no_app_for_now: 'No mobile app for now',
  },
  toasts: {
    something_went_wrong: 'Something went wrong, please try to refresh the page or contact tech support!',
    failed_to_save_changes: 'Could not save the changes, please contact tech support!',
    changes_got_saved: 'Changes got saved successfully!',
  },
};
